// The low-usage tier of the budget bars is a bright yellow (#FFCD00) — fine as a
// bar fill, but unreadable as text on white. Use this for any percentage/amount
// text that takes its color from the bar; every other tier is returned unchanged.
const BAR_YELLOW = "#FFCD00";
const TEXT_YELLOW = "#B8860B"; // same dark gold the budget request modal uses

export const getBudgetTextColor = (barColor) => (barColor === BAR_YELLOW ? TEXT_YELLOW : barColor);

// The bar's fill for how much of a budget is used: red from 80%, orange from 50%, yellow below. Same tiers as the
// Copilot user modal's budget bar.
export const getBudgetBarColor = (pct) => {
  if (pct >= 80) return "#E2231A";
  if (pct >= 50) return "#F28C00";
  return BAR_YELLOW;
};
